'use strict';
import {epicErrorHandler} from '../../../core-utilities/rx-utils';
import {navToEntity} from '../actions/navigation';
import {logger} from './logger';

export const epics = [
  onNavToEntity,
];

onNavToEntity.$inject = [
  'appNavigatorService',
];


/**
 * @param {ActionsObservable<ReduxAction>} action$
 * @param {Store} store
 * @param dependencies
 * @return {Observable.<ReduxAction>}
 */
function onNavToEntity(action$, store, dependencies) {
  return action$.ofType(navToEntity.TYPE)
  // use the existing implementation for now.
  // It can be converted to an epic instead of a service if appropriate later.
    .switchMap(action => dependencies.appNavigatorService.goToLink(action.payload))
    .filter(() => false)
    .catch(epicErrorHandler(logger, 'onNavToEntity'));
}



// WEBPACK FOOTER //
// ./src/js/app/model/epics/onNavToEntity.js